import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class DeductibleIndividualNonZero extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/06_individual_deductible.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Your deductible, explained</H2>

            <P>
              First up: your deductible&mdash;the amount you'll pay for covered services before your
              insurance starts to chip in.
            </P>

            <P>
              You'll pay full price for most care until you hit your individual in-network{' '}
              deductible&mdash;unless it's preventative care which is typically covered fully.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default DeductibleIndividualNonZero;
